import { createRouter, createWebHistory } from "vue-router";
import OnePage from "@/layouts/OnePage.vue";
import SobreNos from "@/views/sobre/NossaHistoria.vue";
import Eventos from "@/views/eventos/Eventos.vue";
import Videos from "@/views/videos/Videos.vue";
import AcaoSocial from "@/views/acaoSocial/AcaoSocial.vue";
import EscolaCrescimento from "@/views/escolaCrescimento/EscolaCrescimento.vue";
import MinisterioMulheres from "@/views/ministerioMulheres/MinisterioMulheres.vue";

const routes = [
  {
    path: "/",
    name: "onePage",
    component: OnePage,
  },
  {
    path: "/historia",
    name: "historia",
    component: SobreNos,
  },
  {
    path: "/eventos",
    name: "eventos",
    component: Eventos,
  },
  {
    path: "/cultos",
    name: "cultos",
    component: Videos,
  },
  {
    path: "/acao-social",
    name: "acaoSocial",
    component: AcaoSocial,
  },
  {
    path: "/escola-crescimento",
    name: "escolaCrescimento",
    component: EscolaCrescimento,
  },
  {
    path: "/ministerio-mulheres",
    name: "ministerioMulheres",
    component: MinisterioMulheres,
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // Para a página escola-crescimento, deixar o componente gerenciar o scroll
    if (to.name === 'escolaCrescimento' && to.hash) {
      return false;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
});

// Debug para verificar navegação
router.beforeEach((to, from, next) => {
  console.log('🔀 [Router] Navegando:', {
    de: from.path,
    para: to.path,
    hash: to.hash,
    fullPath: to.fullPath
  })
  next()
})

export default router;
